
// ── Components ───────────────────────────────────────────────────────────────

export default function MotionTemplate1() {
  return (
    <div className="space-y-8 pb-20 animate-[fade-in_1s_ease-out]">
      {/* 1. System Status Header */}
      <div className="flex items-center justify-between p-6 bg-slate-900 border border-teal-500/20 rounded-2xl shadow-2xl relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-teal-500/50 via-teal-500 to-teal-500/50 animate-[shimmer_2s_infinite]" />
        <div className="flex items-center gap-6">
           <div className="w-3 h-3 rounded-full bg-teal-500 animate-pulse shadow-[0_0_15px_rgba(20,184,166,0.8)]" />
           <div>
              <h1 className="text-teal-500 font-mono text-xl font-bold tracking-[0.2em] uppercase">System_Active // HQ_Backbone</h1>
              <p className="text-teal-500/40 font-mono text-[10px] mt-1 tracking-widest">Protocol 4.6.10 // Nodes: 143 // Latency: 12ms</p>
           </div>
        </div>
        <div className="flex gap-4 font-mono text-[10px]">
           <div className="px-4 py-2 border border-teal-500/30 rounded text-teal-500/60 hover:bg-teal-500/5 transition-colors cursor-pointer">SYS_LOG</div>
           <div className="px-4 py-2 bg-teal-500 text-slate-900 font-bold rounded hover:bg-teal-400 transition-colors cursor-pointer">REBOOT_ALL</div>
        </div>
      </div>

      {/* 2. Real-time Node Monitoring Grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
        {Array.from({ length: 10 }).map((_, i) => (
          <div 
            key={i}
            className="group p-5 bg-slate-900/50 border border-white/5 rounded-xl hover:border-teal-500/30 transition-all duration-300 relative overflow-hidden"
          >
             <div className="absolute top-0 left-0 w-1 h-full bg-teal-500/10 group-hover:bg-teal-500 transition-all duration-500" />
             <div className="flex justify-between items-start mb-4">
                <span className="font-mono text-[9px] text-white/20 uppercase tracking-tighter">Node_{String(i + 101).padStart(3, '0')}</span>
                <span className="material-symbols-outlined text-[14px] text-teal-500/30 group-hover:text-teal-500 animate-spin-slow">settings</span>
             </div>
             <div className="space-y-1">
                <p className="text-white font-mono text-lg font-bold group-hover:text-teal-400 transition-colors">89.4%</p>
                <div className="h-0.5 w-full bg-white/5 rounded-full overflow-hidden">
                   <div className="h-full bg-teal-500/50 w-4/5 animate-pulse" />
                </div>
             </div>
             <p className="text-[9px] font-mono text-white/40 mt-3 tracking-widest">CPU_LOAD_CRITICAL</p>
          </div>
        ))}
      </div>

      {/* 3. Advanced Terminal Feed */}
      <div className="bg-black border border-white/5 rounded-2xl overflow-hidden font-mono text-[11px] shadow-2xl">
        <div className="p-4 bg-white/5 border-b border-white/5 flex items-center gap-2">
           <div className="w-2 h-2 rounded-full bg-rose-500/50" />
           <div className="w-2 h-2 rounded-full bg-amber-500/50" />
           <div className="w-2 h-2 rounded-full bg-teal-500/50" />
           <span className="ml-4 text-white/20 tracking-widest text-[9px]">SHELL_v2.0 // ROOT@MC_HQ</span>
        </div>
        <div className="p-8 space-y-3 max-h-80 overflow-y-auto no-scrollbar">
           <p className="text-teal-500/80"><span className="text-teal-500/30 mr-4">12:00:01</span> {'>'} INITIATING_SYNC --TARGET:fm.Schools</p>
           <p className="text-white/60"><span className="text-white/10 mr-4">12:00:02</span> [OK] CONNECTION_ESTABLISHED // SQL_PROX_SERVER</p>
           <p className="text-white/60"><span className="text-white/10 mr-4">12:00:04</span> [DATA] FETCHING_ROWS: 143_RECORDS_RECEIVED</p>
           <p className="text-teal-400"><span className="text-teal-500/10 mr-4">12:00:05</span> [SUCCESS] MAPPING_COMPLETE // UI_UPDATED</p>
           <p className="text-white/20 mt-6 animate-pulse">_</p>
        </div>
        <div className="p-4 bg-teal-500/5 border-t border-white/5">
           <div className="flex gap-4 text-[9px] text-teal-500/40">
              <span className="hover:text-teal-500 cursor-pointer transition-colors">CLEAR_BUFFER</span>
              <span className="hover:text-teal-500 cursor-pointer transition-colors">SAVE_DUMP</span>
              <span className="hover:text-teal-500 cursor-pointer transition-colors">KILL_PROCESS</span>
           </div>
        </div>
      </div>

      {/* 4. Motion Dashboard Widgets */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
         <div className="bg-slate-900 border border-white/5 rounded-3xl p-10 relative overflow-hidden group">
            <div className="absolute top-0 right-0 w-full h-full bg-gradient-to-br from-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-1000" />
            <h3 className="text-white/50 font-mono text-[10px] uppercase tracking-widest mb-10">// Network_Traffic_Pulse</h3>
            <div className="flex items-end gap-1 h-32">
               {Array.from({ length: 24 }).map((_, i) => (
                 <div 
                   key={i} 
                   className="flex-1 bg-teal-500/20 rounded-t-sm animate-[bounce_2s_infinite_ease-in-out]" 
                   style={{ height: `${Math.random() * 100}%`, animationDelay: `${i * 100}ms` }} 
                 />
               ))}
            </div>
         </div>
         
         <div className="bg-slate-900 border border-white/5 rounded-3xl p-10 flex flex-col justify-between group">
            <div className="flex justify-between items-start">
               <h3 className="text-white/50 font-mono text-[10px] uppercase tracking-widest">// Security_Audit</h3>
               <span className="px-3 py-1 rounded-full bg-rose-500/10 text-rose-500 font-bold text-[9px]">3 THREATS</span>
            </div>
            <div className="my-10 space-y-4">
               <div className="flex items-center gap-4 text-white/80">
                  <span className="material-symbols-outlined text-rose-500 animate-pulse">warning</span>
                  <p className="text-sm font-bold">Unauthorized access attempt: IP 192.168.1.1</p>
               </div>
               <div className="flex items-center gap-4 text-white/40">
                  <span className="material-symbols-outlined !text-sm">verified_user</span>
                  <p className="text-xs">Brute force protection active</p>
               </div>
            </div>
            <button className="w-full py-4 bg-white/5 hover:bg-white/10 border border-white/10 rounded-2xl text-teal-500 font-mono text-[10px] uppercase tracking-widest transition-all">Download Audit Report</button>
         </div>
      </div>
    </div>
  )
}
